export const INDEX_INVESTMENT_ATTEMPT = 'INDEX_INVESTMENT_ATTEMPT';
export type INDEX_INVESTMENT_ATTEMPT = typeof INDEX_INVESTMENT_ATTEMPT;

export const INDEX_INVESTMENT_SUCCESS = 'INDEX_INVESTMENT_SUCCESS';
export type INDEX_INVESTMENT_SUCCESS = typeof INDEX_INVESTMENT_SUCCESS;

export const INDEX_INVESTMENT_FAILURE = 'INDEX_INVESTMENT_FAILURE';
export type INDEX_INVESTMENT_FAILURE = typeof INDEX_INVESTMENT_FAILURE;



// WEBPACK FOOTER //
// ./src/actions/investment/index/Types.tsx